<template>
  <span>
    <div class="mb-3 vx-row">
      <div id="customer_details" class="w-full vx-col">
        <vx-card>
          <div class="w-full con-expand-users">
              <div class="flex items-center justify-between con-btns-user">
                <div class="flex items-center justify-start con-userx">
                  <vs-avatar color="primary" :text="supplierDetails.company_name"/>
                  <span class="font-semibold text-primary">{{ supplierDetails.company_name }}
                    <span v-if="supplierDetails.account_number">({{ supplierDetails.account_number}})</span>
                  </span>
                </div>
              </div>
            </div>
        </vx-card>
      </div>
    </div>
    <vs-tabs v-on:input="onClickTabs"
      :value="active_step" :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen + '_' + !!supplierDetails.is_spray_dry_supplier">

    <!-- GENERAL -->
    <vs-tab v-if="$canAny(['view-supplier'])" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'General Details' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-profile-details-view @supplier-updated="fetchSupplierdata"/>
      </div>
    </vs-tab>
    <vs-tab v-if="$canAny(['view-supplier-users','create-edit-supplier-users'])" icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Users' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <suppliers-users-list :is_supplier_activated="supplierDetails.is_supplier_activated" :sage_id="supplierDetails.sage_id"/>
      </div>
    </vs-tab>
    <vs-tab v-if="$canAny(['view-supplier-manufacturing-sites','create-edit-supplier-manufacturing-sites'])" icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Supplier Sites' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <suppliers-manufacture-list/>
      </div>
    </vs-tab>
        <vs-tab v-if="$canAny(['view-supplier-raw-materials','create-edit-supplier-raw-materials'])" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Raw Material' : ''">
          <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
            <suppliers-raw-material-list/>
          </div>
        </vs-tab>
    <vs-tab v-if="$canAny(['view-raw-material-orders'])" icon-pack="feather" icon="icon-archive" :label="!isSmallerScreen ? 'Purchase History' : ''">
          <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
             <RMOrdersList :supplierId="supplier_id"/>
          </div>
    </vs-tab>
    <vs-tab v-if="supplierDetails.is_spray_dry_supplier" icon-pack="feather" icon="icon-file-text" :label="!isSmallerScreen ? 'QC Documentation' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-qc-documentation-view/>
      </div>
    </vs-tab>
  </vs-tabs>
  </span>
</template>

<script>
  import SuppliersManufactureList from './SuppliersManufactureList.vue'
  import SuppliersRawMaterialList from './SuppliersRawMaterialList.vue'
  import SupplierProfileDetailsView from './SupplierProfileDetailsView.vue'
  import SuppliersUsersList from './SuppliersUsersList.vue'
  import SupplierQCDocumentationView from './SupplierQCDocumentationView.vue'

  import { RepositoryFactory } from '@/repository/RepositoryFactory';
import RMOrdersList from '../../raw-material/rm-orders/RMOrdersList.vue'
  const SupplierRepository = RepositoryFactory.get('supplier');

  export default {
    components: {
      SuppliersManufactureList,
      SupplierProfileDetailsView,
      SuppliersUsersList,
      SuppliersRawMaterialList,
      RMOrdersList,
      'supplier-qc-documentation-view': SupplierQCDocumentationView,
    },
    data () {
      return {
        // active_step: this.$route.query.step ? this.$route.query.step : '0',
        supplierDetails: {
          is_supplier_activated: 0
        },
        supplier_id: null
      }
    },
    async mounted() {
        // this.active_step = this.$route.query.step
        await this.fetchSupplierdata()
    },
    methods: {
      onClickTabs(step) {
        this.$router.push({query: {step: step} }).catch(()=>{});
      },
      async fetchSupplierdata() {
        this.supplier_id = this.$route.params.id
        const { data } = (await SupplierRepository.getBasicSupplierDetails(this.supplier_id)).data
        this.supplierDetails = data
      }
    },
    computed: {
      isSmallerScreen () {
        return this.$store.state.windowWidth < 768
      },
      active_step() {
        return this.$route.query.step ? this.$route.query.step : '0'
      }
    }
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
